import * as TYPES from '@app/store/actionTypes';
import { TemplateAction, templateDataFetched } from '@app/store/template/actions';

type TemplateLabelIdsState = string[];

const initialState: TemplateLabelIdsState = [];

export default function reducer(
  state: TemplateLabelIdsState = initialState,
  action: TemplateAction
) {
  switch (action.type) {
    case TYPES.TEMPLATE_CLEAR_ALL_STATE:
      return initialState;
    case TYPES.TEMPLATE_INFORMATION_FETCH_SUCCESS:
    case templateDataFetched.type:
      return action.payload.labelIds;
    case TYPES.TEMPLATE_LABEL_IDS_CHANGE:
      return action.payload.labelIds;
    default:
      return state;
  }
}
